import { IBank } from '../../types/banksList';

export function banksListReducer(state: IBank[] = []): IBank[] {
  return state;
}
